import { Injectable } from '@angular/core';
import { Details } from '@details/Interfaces/details';
import { blank, nameOnly, simple, anchor, DetailsItemType, DetailsItem } from '@details/Interfaces/details-item-types';
import { LayoutOrientation } from '@common/enums/layout-orientation';
import { DebtorDetails } from '@debtors/models/debtor-details';
import { has, DetailsBuilder } from '@details/Interfaces/details-builder';
//import { DataFormatter } from '@common/services/data-formatter.service';
import { as } from '@common/string-formatter/string-formatter';

@Injectable({
  providedIn: 'root'
})
export class DebtorDetailsMapperService {

  constructor(
    //   private readonly formatter: DataFormatter
  ) { }

  mapToDetails(details: DebtorDetails): Details {


    const onStop = as(details.StopFlag, 'OnStopExpansion');
    const b = new DetailsBuilder(`Reference ${details.AccountNo}${onStop ? ` - ${onStop}` : ''}`, details);


    b.section(`${details.DebtorType} debtor`, LayoutOrientation.Vertical)
      .always(nameOnly(details.BillingName))
      .for('StrungAddress', 'Address:');

    b.conditionalSection(has(details.VatReg, details.RegisteredCompanyNumber), null, LayoutOrientation.Horizontal)
      .for('VatReg', 'Vat registration:')
      .for('RegisteredCompanyNumber', 'Registered Company No:');

    b.conditionalSection(has(details.ContactName, details.Phone, details.DirectPhone, details.MobilePhone, details.Email, details.Fax),
      'Contact',
      LayoutOrientation.Horizontal)
      .for('ContactName', 'Name:')
      .telFor('Phone', 'Phone:')
      .telFor('DirectPhone', 'Direct phone:')
      .telFor('MobilePhone', 'Mobile phone:')
      .mailFor('Email', 'Email:')
      .for('Fax', 'Fax:');

    const demandsCorrespondenceMethod = as(details.DemandsPreferredMethodOfContact, 'MethodOfContact');
    const remittanceCorrespondenceMethod = as(details.RemittancePreferredMethodOfContact, 'MethodOfContact');

    b.section('Additional Information', LayoutOrientation.Horizontal)
      .for('TurnoverContactName', 'Turnover contact')
      .always(blank())
      .always(nameOnly('Remittance contact details:'))
      .for('RemittanceContactName', 'Name:')
      .mailFor('RemittanceEmail', 'Email:')
      .for('RemittanceFax', 'Fax:')
      .conditionalItem(remittanceCorrespondenceMethod,
        simple(`Remittance is sent via ${remittanceCorrespondenceMethod}`, null))
      .always(blank())
      .always(nameOnly('Demands, arrears, ad-hoc contact details:'))
      .for('DemandsContactName', 'Name:')
      .mailFor('DemandsEmail', 'Email:')
      .for('DemandsFax', 'Fax:')
      .conditionalItem(demandsCorrespondenceMethod,
        simple(`Correspondence is sent via ${demandsCorrespondenceMethod}`, null));

    b.section('Financial details', LayoutOrientation.Horizontal)
      .always(nameOnly(`This debtor is in the category ${details.DebtorCategoryDescription}`))
      .conditionalItem(details.InvoiceRequired === 'Y', nameOnly('Invoice is required'))
      .conditionalItem(has(details.DemandLanguageCode),
        nameOnly(`Demands are produced in ${details.DemandLanguageDescription}`))
      .conditionalItem(has(details.BillingCurrencyCode),
        nameOnly(`Billing currency is ${details.BillingCurrencyDescription}`))
      .conditionalItem(has(details.UsualPaymentMethod),
      nameOnly(`Usually pay by ${details.UsualPaymentMethod}`))
      .always(blank())
      .for('CreditRating', `Credit rating is:`)
      .conditionalItem(details.ArrearsLetter === 'Y', nameOnly(`Arrears letters production is allowed`))
      .conditionalItem(has(details.DaysToOverdue), nameOnly(`No of days until amounts are overdue are ${details.DaysToOverdue}`))
      ;

    return b.getDetails();

  }

}
